import { useTranslation } from 'next-i18next';
import { BoltSmallRectangleColorMintIcon } from '@/icons';
import { useCountryCode } from '@/shared/hooks';
import { useFirstPurchaseDiscount } from '@/shared/hooks/useFirstPurchaseDiscount';
import { usePrices } from '@/shared/hooks/usePrices';
import { useFeatureStrings } from '@/shared/plan/useFeatureStrings';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
import * as PricingCard from './PricingCard';
export const BasicPricingCard = (props: PricingCard.PricingCardProps) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    className,
    isEmphasized,
    ctaButtonText: ctaButtonTextProp,
    ctaButtonDisabled,
    onCtaButtonClick,
    secondaryCtaText,
    onSecondaryCtaClick,
    footer
  } = props;
  const ctaButtonText = ctaButtonTextProp ?? t('common:pricing.pro.purchase');
  const {
    countryCode
  } = useCountryCode();
  const {
    isEligible,
    discountRate
  } = useFirstPurchaseDiscount();
  const shouldEmphasize = isEmphasized ?? isEligible;
  const {
    displayOriginalPrice,
    displayFinalPrice,
    displayCurrency
  } = usePrices({
    countryCode,
    planType: 'BASIC'
  });
  const featureStrings = useFeatureStrings(countryCode);
  return <PricingCard.Container className={cn(shouldEmphasize && 'p-[2px] border-0 bg-gradient-mint-green !shadow-[0px_4px_12px_0px_rgba(60,216,76,0.12),0px_0px_16px_0px_rgba(60,216,76,0.2)]', className)} data-sentry-element="unknown" data-sentry-component="BasicPricingCard" data-sentry-source-file="BasicPricingCard.tsx">
      <PricingCard.TopSection data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx">
        <PricingCard.Header data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx">
          <BoltSmallRectangleColorMintIcon size="xl" data-sentry-element="BoltSmallRectangleColorMintIcon" data-sentry-source-file="BasicPricingCard.tsx" />
          <h2 className="text-heading-xl-extrabold">Basic</h2>
        </PricingCard.Header>
        <PricingCard.PaidPlanPrice listPrice={displayOriginalPrice} finalPrice={displayFinalPrice} currency={displayCurrency} discountRate={discountRate} isFirstPurchase={isEligible} data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx" />
        <PricingCard.Description data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx">
          {t('common:pricing.basic.description')}
        </PricingCard.Description>
        <div className="mt-auto flex flex-col gap-2xs">
          <Button intent="alternative" size="lg" className={cn('w-full', shouldEmphasize && 'bg-gradient-to-r from-mint-600 to-green-500 border-transparent hover:from-mint-700 hover:to-green-600 text-white')} disabled={ctaButtonDisabled} onClick={onCtaButtonClick} data-sentry-element="Button" data-sentry-source-file="BasicPricingCard.tsx">
            {ctaButtonText}
          </Button>
          {secondaryCtaText && <PricingCard.SecondaryCta text={secondaryCtaText} onClick={onSecondaryCtaClick} />}
        </div>
      </PricingCard.TopSection>

      <PricingCard.Divider data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx" />

      <PricingCard.BottomSection data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx">
        <PricingCard.FeatureTitles mainTitle={t('common:pricing.pro.usefulFeatures')} subTitle={t('common:pricing.pro.includesAllFeatures', {
        plans: 'Free'
      })} data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx" />
        <PricingCard.FeatureItemList items={featureStrings.BASIC.normalFeatures} data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx" />
        <PricingCard.AiFeatureItemList title="QUIZ AI" items={featureStrings.BASIC.aiFeatures} data-sentry-element="unknown" data-sentry-source-file="BasicPricingCard.tsx" />
      </PricingCard.BottomSection>
      {footer}
    </PricingCard.Container>;
};